import Lightbox from "../../../elements/lightbox/lightbox";

class MotiveLightbox extends Lightbox {
  /**
   * @param {HTMLElement} element - the motive element
   */
  constructor(element) {
    super(element);

    this.config = {
      selectors: {
        lightBoxPreviewPDFText: ".js-MotiveLightbox-text",
        lightBoxPreviewPDFImage: ".js-MotiveLightbox-image",
      },
    };

    this.lightBoxPreviewPDFImages = [
      ...element.querySelectorAll(
        this.config.selectors.lightBoxPreviewPDFImage
      ),
    ];

    this.lightBoxPreviewPDFText = element.querySelector(
      this.config.selectors.lightBoxPreviewPDFText
    );

    this.lightBoxPreviewPDFImage = element.querySelector(
      this.config.selectors.lightBoxPreviewPDFImage
    );

    this.lightBoxPreviewPDFImageName = "";

    this.updatePreviewPDF = this.updatePreviewPDF.bind(this);
  }

  /**
   *
   * @param {string} previewText
   * @param {string} previewImageVariant
   */
  updatePreviewPDF(previewText, previewImageVariant) {
    // update the text
    this.lightBoxPreviewPDFText.textContent = previewText;

    // update the image only if the motive image has been changed
    if (previewImageVariant !== this.lightBoxPreviewPDFImageName) {
      this.lightBoxPreviewPDFImages.forEach((image) => {
        // eslint-disable-next-line no-param-reassign
        image.hidden =
          image.getAttribute("data-variant") !== previewImageVariant;
      });
      this.lightBoxPreviewPDFImageName = previewImageVariant;
    }
    super.openLightbox();
  }
}

export default MotiveLightbox;
